export default "__VITE_ASSET__DuaRgVnm__"